module.exports = __webpack_public_path__ + "img/tool-youtube.717e57c.webp";